interface BasicApiError {
  [index: string]: unknown,
  status: number,
  responseJSON: {
    [index: string]: unknown
  }
}

interface ApiError extends BasicApiError {
  responseJSON: {
    [index: string]: unknown,
    error: {
      type: string,
      message: string,
      detail?: { [index: string]: string }
    }
  }
}

function isBasicApiError (error: unknown): error is BasicApiError {
  return typeof error === 'object' && !!error && 'status' in error && 'responseJSON' in error
}

export function errorIsApiError (error: unknown): error is ApiError {
  if (isBasicApiError(error) && typeof error.responseJSON === 'object') {
    const json = error.responseJSON || {}
    return 'error' in json
  }
  return false
}

interface BasicGraphqlError {
  message: string,
  graphQLErrors: unknown
}

interface GraphqlError{
  message: string,
  graphQLErrors: [{
    message: string,
    extensions: {
      [index: string]: string | undefined | { [index: string]: string },
      type: string,
      detail?: { [index: string]: string }
    }
  }]
}

function isBasicGraphqlError (error: unknown): error is BasicGraphqlError {
  return typeof error === 'object' && !!error && 'message' in error && 'graphQLErrors' in error
}

export function errorIsGraphqlError (error: unknown): error is GraphqlError {
  if (isBasicGraphqlError(error)) {
    return !!(Array.isArray(error.graphQLErrors) && error.graphQLErrors.length && error.graphQLErrors[0]?.extensions?.type)
  }
  return false
}
